import { Pipe, PipeTransform } from '@angular/core';

import { exportSecMin } from '../../../apps/manager/src/app/shared/utils';

@Pipe({
  name: 'bigTimeFormatLetters',
})
export class BigTimeFormatLettersPipe implements PipeTransform {
  transform(value: number, noCaret = false, ...args: unknown[]): string {
    if (!noCaret && value === 0) {
      return '-';
    }
    const { minutes, hours, seconds } = exportSecMin(value);

    if (!minutes && !hours) {
      return `${seconds} sec`;
    }
    let format = hours ? `${hours} h ` : '';
    if (minutes) {
      format = format + `${minutes} min`;
    }

    return format;
  }
}
